<template>

  <div class="video-thumbnail" @click="openVideo">
    <img :src="thumbnailUrl" alt="Video Thumbnail">
    <div class="play-indicator">Click to play video</div>
  </div>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      required: true
    }
  },
  computed: {
    thumbnailUrl() {
      return `https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg`;
    }
  },
  methods: {
    openVideo() {
      window.open(`https://www.youtube.com/watch?v=${this.videoId}`, '_blank');
    }
  }
}
</script>

<style scoped>
.video-thumbnail {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.play-indicator {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  text-align: center;
}
</style>
